import {
  FaAngular,
  FaReact,
  FaVuejs,
  FaSass,
  FaBootstrap,
  FaNodeJs,
  FaShopify
} from "react-icons/fa";
import {
  SiNextdotjs,
  SiNuxtdotjs,
  SiTailwindcss,
  SiMaterialdesign,
  SiFirebase,
  SiStrapi,
  SiMongodb,
  SiNestjs,
  SiMysql,
} from "react-icons/si";
import { BiLogoPostgresql } from "react-icons/bi";
import { GrGraphQl } from "react-icons/gr";

export const frontendSkills = [
    { icon: FaAngular, label: "Angular" },
    { icon: FaReact, label: "React" },
    { icon: SiNextdotjs, label: "Next.js" },
    { icon: FaVuejs, label: "Vue" },
    { icon: SiNuxtdotjs, label: "Nuxt.js" },
    { icon: SiTailwindcss, label: "Tailwind.css" },
    { icon: FaSass, label: "Sass" },
    { icon: FaBootstrap, label: "Bootstrap" },
    { icon: SiMaterialdesign, label: "Material" },
  ];
  
  export const backendSkills = [
    { icon: FaNodeJs, label: "NodeJs" },
    { icon: SiNestjs, label: "NestJS" },
    { icon: FaShopify, label: "Shopify" },
    { icon: SiStrapi, label: "Strapi" },
    { icon: SiFirebase, label: "Firebase" },
    { icon: GrGraphQl, label: "GraphQL" },
    { icon: BiLogoPostgresql, label: "PostgreSQL" },
    { icon: SiMongodb, label: "MongoDB" },
    { icon: SiMysql, label: "MySQL" },
  ];
  
  export const bulletPointItems = [
    "Performance Optimization",
    "Component-Driven Development",
    "Design System & Theming",
    "Code Maintainability & Best Practices",
    "Debugging & Issue Resolution",
    "State Management Strategies",
    "Workflow Automation & CI/CD",
    "Cross-Framework Adaptability"
  ];